import { Stack, Typography, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Pagination, Box } from "@mui/material";
import { grey } from "@mui/material/colors";
import { IDataTable } from "src/types/organisms";
import LoadingGif from "../../../assets/gifs/loading.gif";
import EmptyImg from "../../../assets/images/empty.png";
const DataTable = ({
  isLoading = false,
  headers,
  rows,
  pages,
  currentPage,
  onChangePage,
  emptyMessage = "Sin elementos encontrados",
  bottomRender
}: IDataTable) => {
  const classes = {
    tableContainer: {
      position: "relative",
      minHeight: rows.length === 0 ? 450 : bottomRender ? 760 : 700
    },
    table: {
      "& tr": {
        borderBottom: "1px solid #DEE2E6",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      },
      "thead tr": {
        borderBottomWidth: 2
      },
      "& th, & td": {
        paddingLeft: 0,
        color: grey[600],
        textAlign: "center",
        border: "none",
        width: 1
      }
    },
    pagContainer: {
      justifyContent: "flex-end",
      position: "absolute",
      width: 1,
      bottom: 2
    }
  };
  return <TableContainer sx={classes.tableContainer}>
      <Table sx={classes.table}>
        <TableHead>
          <TableRow>
            {headers.map(head => <TableCell key={`head-${head.id}`}>
                <Typography fontWeight={700}>{head.label}</Typography>
              </TableCell>)}
          </TableRow>
        </TableHead>
        {!isLoading && <TableBody>
            {rows.map((row: any, idx: number) => <TableRow key={`row-${idx}`}>
                {headers.map((head, idx2: number) => {
            const data = row[head.id];
            if (typeof data === "string" || typeof data === "number") {
              return <TableCell key={`data-${idx2}`}>
                        <Typography>{data}</Typography>
                      </TableCell>;
            } else {
              return <TableCell sx={{
                paddingY: 0
              }} key={`data-${idx2}`}>
                        {data}
                      </TableCell>;
            }
          })}
              </TableRow>)}
          </TableBody>}
      </Table>
      {rows.length === 0 ? <Stack direction={"row"} justifyContent={"center"} marginTop={8}>
          <Box component={"img"} display={isLoading ? "block" : "none"} src={LoadingGif} width={170}></Box>
          <Box display={!isLoading ? "block" : "none"} textAlign={"center"}>
            <Box component={"img"} src={EmptyImg}></Box>
            <Typography marginTop={1} color={grey[600]}>
              {emptyMessage}
            </Typography>
          </Box>
        </Stack> : <Stack sx={classes.pagContainer}>
          {bottomRender}
          <Stack direction={"row"} justifyContent={"flex-end"}>
            <Pagination size="large" count={pages} variant="outlined" shape="rounded" sx={{
          color: grey[600]
        }} page={currentPage} onChange={(_, value) => onChangePage(value)} />
          </Stack>
        </Stack>}
    </TableContainer>;
};
export default DataTable;